export default __webpack_public_path__ + "static/media/upload3.719dc4c8.png";